module.exports = __webpack_public_path__ + "img/exit.2c5552a1.svg";